exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3{font-size:1.2rem;font-weight:400}.table-center{text-align:center}.align-middle,.table-center{vertical-align:middle!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-60099b04","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?outputStyle=expanded!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ComponentDoc.vue
// module id = qm7G
// module chunks = 1